module.exports = "<div class=\"banner-org-billing\">\n  <banner show-banner=\"showBanner\" banner-class=\"bannerClass\">\n    <p ng-bind-html=\"bannerText\">\n    </p>\n  </banner>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/bannerOrgBilling/template.html
// module id = 1216
// module chunks = 0